import React from "react";
import { Grid, Paper } from "@material-ui/core";

import Chart from "./charts";
import { AxiosCall } from "../../utils";

const VerifierDashboard = () => {
  const [clientId, setClientId] = React.useState();

  React.useEffect(() => {
    getPersonLoggedIN();
  }, []);

  const getPersonLoggedIN = async () => {
    try {
      let keycloackid = localStorage.getItem("keyclkId");
      let params = {
        db_name: process.env.REACT_APP_DB,
        entity: "Person",
        filter: `Person.keycloackid=='${keycloackid}' && Person.activestatus==true`,
        return_fields: "Person",
      };
      let res = await AxiosCall(
        "post",
        `${process.env.REACT_APP_BASE_URL}/api/read_documents`,
        params
      );
      if (res.result.length > 0) {
        let result = res?.result[0]?._id;
        setClientId(result);

        // setLoading(false);
      } else {
        setClientId(null);
        // setLoading(false);
      }

      // console.log(result);
    } catch (error) {}
  };

  return (
    <Grid container spacing={2}>
      <Grid item lg={12} md={12} xl={12} xs={12}>
        <Chart
          title="Verification"
          basedOn="period"
          uniqueId={clientId}
          filterKey={"verifier"}
          monthlyQueryId={"8c465d2a-b4fb-4bd7-878c-c79eb01c0a26"}
          dateQueryId={"4aa61db9-3fbe-41b1-a282-1cb5139f1107"}
          gridItem={4}
        />
      </Grid>
    </Grid>
  );
};

export default VerifierDashboard;
